import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfoDetails } from '@wilson/interfaces';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { CountriesService } from '@wilson/countries';
import { PipesModule } from '@wilson/pipes';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzInputModule } from 'ng-zorro-antd/input';
@Component({
  selector: 'wilson-general-settings-details',
  templateUrl: './general-settings-details.component.html',
  styleUrls: ['./general-settings-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    PipesModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  providers: [CountriesService],
})
export class GeneralSettingsDetailsComponent {
  @Input({ required: true }) form!: FormGroup<InfoDetails>;
  @Input({ required: true }) hasGeneralSettingsUpdatePermission!: boolean;

  @Output() changeInfoDetails = new EventEmitter();

  onInfoDetailsChange(): void {
    this.changeInfoDetails.emit();
  }
}
